import * as Sentry from "@sentry/nextjs";

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Replay only for errors (not all sessions — saves quota)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    integrations: typeof window !== "undefined" ? [Sentry.replayIntegration()] : [],

    // 10% of transactions in production; 100% in dev
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

    environment: process.env.NODE_ENV,
});
